module.exports = __webpack_public_path__ + "static/media/CMS-luckygames-list.a40c29d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/thumbs/CMS-luckygames-list.png
// module id = 616
// module chunks = 0